import { PRIMARY_COLOR, SECONDARY_COLOR, BACKGROUND_PRIMARY_COLOR } from '../constants/ThemeConstant';
export default {
    colorPrimary: PRIMARY_COLOR,
    colorSecondary: SECONDARY_COLOR,
    backgroundPrimary: BACKGROUND_PRIMARY_COLOR,
    fontFamily: 'Relaway, sans-serif',
    fontSize: 14,
}